// extracted by mini-css-extract-plugin
export default {"container":"QuantityControl_container__nCr5n","btn":"QuantityControl_btn__dcc5T","quantity":"QuantityControl_quantity__XbIho"};